import {AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {DxToolbarComponent} from 'devextreme-angular';
import {dateFilters, dateFilterToPeriod} from 'shared';
import {SensorHistoryRequest} from '../sensor-history-request';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-sensor-history-toolbar',
  templateUrl: './sensor-history-toolbar.component.html',
  styleUrls: ['./sensor-history-toolbar.component.scss']
})
export class SensorHistoryToolbarComponent implements OnInit {

  @ViewChild(DxToolbarComponent, {static: true})
  toolbar: DxToolbarComponent;

  @Input()
  request: SensorHistoryRequest;

  @Input()
  store: ArrayStore;

  dateFilters = dateFilters;

  ds: DataSource;

  constructor() {

    // Bindings
    this.dateFilterChanged = this.dateFilterChanged.bind(this);
  }

  ngOnInit(): void {

    this.store.insert({
      id: 'date',
      location: 'before',
      locateInMenu: 'never',
      template: 'dateTemplate'
    });
    this.store.insert({
      id: 'start',
      location: 'before',
      locateInMenu: 'never',
      visible: false,
      template: 'dateStartTemplate'
    });
    this.store.insert({
      id: 'end',
      location: 'before',
      locateInMenu: 'never',
      visible: false,
      template: 'dateEndTemplate'
    });
    this.store.insert({
      id: 'show',
      location: 'before',
      widget: 'dxButton',
      locateInMenu: 'auto',
      options: {
        icon: 'repeat',
        text: 'Afficher',
        onClick: (e: any) => {
          const result = e.validationGroup.validate();
          if (result.isValid) {
            this.request.submit();
          }
        }
      },
    });

    this.ds = new DataSource({
      store: this.store,
    });
  }

  dateFilterChanged(e) {
    this.request.isToday = false;
    this.request.currentFilter = e.value;
    if (this.request.currentFilter === 0) {
      this.store.push([{type: 'update', data: {visible: true}, key: 'start'}]);
      this.store.push([{type: 'update', data: {visible: true}, key: 'end'}]);
    } else {
      this.store.push([{type: 'update', data: {visible: false}, key: 'start'}]);
      this.store.push([{type: 'update', data: {visible: false}, key: 'end'}]);
    }

    setTimeout(() => {
      this.toolbar.instance.repaint();
    }, 0);

    [this.request.from, this.request.to, this.request.isToday] = dateFilterToPeriod(this.request.currentFilter);
  }
}
